import {useMachine} from '@xstate/react';
import {useEffect} from 'react';

import {ReagentAssignmentGroup, REAGENTS_ATTRIBUTE_SENTINEL} from 'samples/plate-maps/PlateMapConstants';
import {createAssignmentGroupsForAttribute} from 'samples/plate-maps/PlateMapUtil';

import {
  DEFAULT_FILL_PLATE_MODAL_STATE,
  FillPlateModalReducerActionType,
  FillPlateModalState,
} from './machine/FillPlateModalConstants';
import {FillPlateModalMachine} from './machine/FillPlateModalMachine';

export type FillPlateModalReducerDispatch = ReturnType<typeof useMachine<typeof FillPlateModalMachine>>[1];

export default function useFillPlateModalReducer(
  stateAttrs: Partial<FillPlateModalState>
): [FillPlateModalState, FillPlateModalReducerDispatch] {
  const initialState: FillPlateModalState = {
    ...DEFAULT_FILL_PLATE_MODAL_STATE,
    ...stateAttrs,
    // Leave the plate map null for now, it will be populated with assignment groups in INITIALIZE_PLATE_MAP
    plateMap: null,
  };

  const [fillPlateModalState, dispatch] = useMachine(FillPlateModalMachine, {
    input: initialState,
  });

  useEffect(() => {
    const fetchInitialAssignmentGroups = async (): Promise<void> => {
      const assignmentGroups = (await createAssignmentGroupsForAttribute(
        stateAttrs.plateMap!,
        REAGENTS_ATTRIBUTE_SENTINEL
      )) as {[id: string]: ReagentAssignmentGroup};
      dispatch({
        type: FillPlateModalReducerActionType.INITIALIZE_PLATE_MAP,
        plateMap: stateAttrs.plateMap!,
        assignmentGroups,
      });
    };
    if (stateAttrs.plateMap != null) {
      fetchInitialAssignmentGroups();
    }
  }, [stateAttrs.plateMap, dispatch]);
  return [fillPlateModalState.context, dispatch];
}
